module.exports = __webpack_public_path__ + "img/kitchen_3_tn.4213377a.jpg";